var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgInstallMobile = function SvgInstallMobile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32.181,
    height: 32,
    viewBox: "0 0 32.181 32",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.454 24.727h-14.545v-17.455h10.182v-7.2727h-10.182c-1.6 0-2.909 1.3091-2.909 2.9091v26.182c0 1.6 1.309 2.9091 2.909 2.9091h14.545c1.6 0 2.909-1.3091 2.909-2.9091v-7.2727h-2.909z",
    strokeWidth: 1.4545
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m21.908 18.909 7.2725-7.2727-2.0508-2.0509-3.7672 3.7527v-10.429h-2.909v10.429l-3.7672-3.7527-2.0508 2.0509z",
    strokeWidth: 1.4545
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgInstallMobile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/install_mobile.ee93b0bf.svg";
export { ForwardRef as ReactComponent };